import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SchoolLoginStore {

}

export enum SchoolLoginStoreKeys {

}
